import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import SmsChannelContainer from './sms/container/SmsChannelContainer';
import EmailChannelContainer from './email/container/EmailChannelContainer';
import EmailTemplateContainer from './emailTemplate/container/EmailTemplateContainer';
import PushChannelContainer from './push/container/PushChannelContainer';
import CustomChannelContainer from './custom/container/CustomChannelContainer';
import TelegramSetting from './telegramSetting/container/TelegramChannelContainer';
import WhatsAppChannel from './whatsAppChannel';
import WebPushChannelContainer from './webpush/container/WebPushChannelContainer';

function channels(props) {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${match.path}sms`}>
        <SmsChannelContainer />
      </Route>
      <Route exact path={`${match.path}email`}>
        <EmailChannelContainer />
      </Route>
      <Route exact path={`${match.path}whatsapp`}>
        <WhatsAppChannel />
      </Route>
      <Route exact path={`${match.path}telegram`}>
        <TelegramSetting />
      </Route>
      <Route exact path={`${match.path}template`}>
        <EmailTemplateContainer />
      </Route>
      <Route exact path={`${match.path}push`}>
        <PushChannelContainer {...props} />
      </Route>
      <Route exact path={`${match.path}custom`}>
        <CustomChannelContainer />
      </Route>
      <Route exact path={`${match.path}webpush`}>
        <WebPushChannelContainer {...props} />
      </Route>
    </Switch>
  );
}

export default channels;
